import axios from 'axios';
import apisUrls from '../urls';

const deleteDeviceApi =  (id) => {
  return axios.delete(`${apisUrls?.deleteDevice}?device_id=${id}`);
};

export default deleteDeviceApi;
